function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 1c.557 0 1.06.281 1.338.75l1.996 3.352a.592.592 0 01-.228.822.631.631 0 01-.847-.22L7.763 2.35a.3.3 0 00-.263-.147.3.3 0 00-.263.147L1.284 12.354a.281.281 0 000 .295.299.299 0 00.263.147h11.906a.299.299 0 00.263-.147.281.281 0 000-.295l-2.121-3.451a.592.592 0 01.227-.822.631.631 0 01.848.22l2.121 3.451c.279.468.279 1.03 0 1.499-.279.468-.78.749-1.338.749H1.547c-.557 0-1.06-.281-1.338-.75a1.448 1.448 0 010-1.498L6.162 1.75C6.441 1.281 6.943 1 7.5 1zm3.192 6.272a.482.482 0 010 .683l-3.237 3.237a.483.483 0 01-.683 0L5.232 9.65a.482.482 0 11.681-.683l1.2 1.2 2.896-2.896a.483.483 0 01.683 0z",
  fill: "#2AB770"
}))));